<template>
    <li
        class="effect-list__item"
        :class="{
            active: selected,
            bottom: this.bottom,
            disabled: disabled,
        }"
        ref="effectItem"
        v-click-outside="hidePreview"
    >
        <div class="effect-list__card" @click="select()">
            <div class="effect-list__icon"></div>
            <!--<div class="effect-list__img">
                <img :src="effect.icon" alt="" />
            </div>-->
            <div class="effect-list__col">
                <div class="effect-list__name">
                    {{ effect.name }}
                </div>
                <div class="effect-list__annotation" v-if="annotation">
                    {{ annotation }}
                </div>
                <div
                    class="effect-list__link"
                    @click.prevent="showPreview"
                    @mouseenter="isMobile ? null : showPreview()"
                    @mouseleave="isMobile ? null : hidePreview()"
                    v-if="false"
                >
                    Смотреть превью
                </div>
            </div>
        </div>
        <div class="effect-preview" v-if="preview">
            <div class="effect-preview__mask" @click="hidePreview"></div>
            <div class="effect-preview__cont">
                <div class="effect-preview__title">
                    <span>Эффект:</span> {{ effect.name }}
                </div>
                <button class="effect-preview__close" @click="hidePreview">
                    <i class="icon-close"></i>
                </button>
                <div class="effect-preview__img">
                    <img :src="effect.imgPreview" alt="" />
                </div>
            </div>
        </div>
    </li>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
    name: "EffectItem",
    data() {
        return {
            isMobile: false,
            bottom: false
        };
    },
    props: {
        effect: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        selected() {
            return this.$store.getters.selectedEffect == this.effect.id;
        },
        preview() {
            return this.$store.getters.previewedEffect == this.effect.id;
        },
        disabled() {
            return !this.$store.getters.allowedEffects[this.effect.id];
        },
        modeSelectorVisible() {
            return this.$store.getters.modeSelectorVisible;
        },
        total() {
            return this.$store.getters.total;
        },
        annotation() {
          if (this.$store.getters.paidMode) {
            if (!this.effect.minDonation || !this.effect.donationEnabled) {
              return '';
            }
            return `от ${this.effect.minDonation} ${this.$store.getters.currencySymbol}`;
          }
          return this.$store.getters.effectClasses.find(cls => cls.id === this.effect.cls)?.name
        },
    },
    methods: {
        handleResize() {
            if (window.matchMedia("(max-width: 767px)").matches) {
                this.isMobile = window.matchMedia("(max-width: 767px)").matches;
            } else if ("ontouchstart" in document.documentElement) {
                this.isMobile = true;
            }
        },
        showPreview() {
            this.bottom =
                this.$refs.effectItem.getBoundingClientRect().top + 440 >
                window.innerHeight;
            this.$store.dispatch('previewEffect', this.effect.id);
        },
        hidePreview() {
            this.$store.dispatch('previewEffect', null);
        },
        async select() {
            this.$store.dispatch('selectEffect', this.effect.id);
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        if (window.matchMedia("(max-width: 767px)").matches) {
            this.isMobile = window.matchMedia("(max-width: 767px)").matches;
        } else if ("ontouchstart" in document.documentElement) {
            this.isMobile = true;
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    directives: {
        ClickOutside
    }
};
</script>
